import { Dispatch, SetStateAction, useEffect } from "react";
import { ReportSummaryApi, ReportSummaryItemApi } from "../api/Reports";

/**
 * When a paginated report list refetches (e.g. after unlock), keep the open modal's
 * selected row aligned with the latest lock + workflow_run_uuid.
 *
 * Several endpoints reuse {@link ReportSummaryApi}; the items live under `report_summaries`
 * even outside a "summaries" product screen.
 */
export function useSyncSelectedReportFromList(
  selectedReport: ReportSummaryItemApi | undefined,
  setSelectedReport: Dispatch<SetStateAction<ReportSummaryItemApi | undefined>>,
  reportsData: ReportSummaryApi | undefined
): void {
  useEffect(() => {
    if (!selectedReport || !reportsData?.report_summaries) return;
    const match = reportsData.report_summaries.find(
      (r) => r.report_uuid === selectedReport.report_uuid
    );
    if (
      match &&
      (match.is_locked !== selectedReport.is_locked ||
        match.workflow_run_uuid !== selectedReport.workflow_run_uuid)
    ) {
      setSelectedReport(match);
    }
  }, [reportsData, selectedReport, setSelectedReport]);
}
